import { useState, useEffect } from "react";
import { RequestTrackingService } from "../../../api/services/RequestTrackingService"; 
import { ServiceRequestProcessingOut } from "../../../api/models/ServiceRequestProcessingOut";

export const useTracking = (serviceRequestId: number) => {
  const [tracking, setTracking] = useState<ServiceRequestProcessingOut[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!serviceRequestId) return;

    const fetchTracking = async () => {
      setLoading(true);
      try {
        const res = await RequestTrackingService.listStatusHistoryServiceRequestsStatusByRequestRequestIdGet(
          serviceRequestId
        );
        setTracking(res);
      } catch (err) {
        console.error("❌ Failed to fetch tracking", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTracking();
  }, [serviceRequestId]);

  return { tracking, loading };
};